var QueueType;
(function (QueueType) {
    QueueType[QueueType["OFFLINE_QUEUE"] = 0] = "OFFLINE_QUEUE";
    QueueType[QueueType["INBOUND_QUEUE"] = 1] = "INBOUND_QUEUE";
    QueueType[QueueType["OUTBOUND_IVR_QUEUE"] = 2] = "OUTBOUND_IVR_QUEUE";
    QueueType[QueueType["PREVIEW_DIALER"] = 3] = "PREVIEW_DIALER";
    QueueType[QueueType["PROGRESSIVE_DIALER"] = 4] = "PROGRESSIVE_DIALER";
    QueueType[QueueType["PREDICTIVE_DIALER"] = 5] = "PREDICTIVE_DIALER";
    QueueType[QueueType["CHAT_INBOUND_QUEUE"] = 6] = "CHAT_INBOUND_QUEUE";
    QueueType[QueueType["INBOUND_JOB_QUEUE"] = 7] = "INBOUND_JOB_QUEUE";
    QueueType[QueueType["OUTBOUND_JOB_QUEUE"] = 8] = "OUTBOUND_JOB_QUEUE";
})(QueueType || (QueueType = {}));
export default QueueType;
//# sourceMappingURL=queue-type.enum.js.map